let navigate: (path: string) => void;

export const setNavigate = (navigateFn: (path: string) => void) => {
  navigate = navigateFn;
};

export const redirectTo = (path: string) => {
  if (navigate) {
    navigate(path);
  } else {
    console.error('Navegación no inicializada');
  }
};